<template>
  <div class="xmtjz-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">新媒体矩阵</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <main class="main-layout">
        <div class="content-wrapper">
          <img :src="xmtjzImg" alt="新媒体矩阵" class="xmtjz-image" />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import xmtjzImg from '@/assets/images/xmtjz.jpg'

export default {
  name: 'Xmtjz',
  data() {
    return {
      xmtjzImg
    }
  }
}
</script>

<style lang="less" scoped>
.xmtjz-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}

.main-layout {
  width: 100%;
}

.content-wrapper {
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
}

.xmtjz-image {
  max-width: 60%;
  height: auto;
  border-radius: 8px;
}
</style>